



































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const couponModule = namespace("coupon");

@Component({})
export default class CouponList extends Vue {
  @couponModule.State("couponList") list!: Array<any>;
  @couponModule.Getter("STATUS") STATUS!: Array<any>;
  name = "";
  searchStatus = "";
  pageNum = 0;
  pageSize = 10;
  pages = 0;
  loading = false;
  finished = false;
  error = false;
  defaultImg = require("@/image/default.png");
  option = [
    { text: "全部", value: "" },
    { text: "已创建", value: 10 },
    { text: "待审核", value: 20 },
    { text: "已投放", value: 30 },
    { text: "已领光", value: 40 },
    { text: "已禁用", value: 50 },
    { text: "已结束", value: 60 }
  ];
  mapType = {
    10:"primary",
    20:"warning",
    30:"success",
    40:undefined,
    50:undefined,
    60:undefined,
  }
  onSearch() {
    this.$store.commit("coupon/resetCouponList");
    this.getCouponList();
  }
  onLoad() {
    this.getCouponList(this.pageNum + 1);
  }

  pageHandler(pageNum: number = 1, pageSize: number = 10) {
    this.$store.dispatch("coupon/getCouponList", {
      businessEntityId: this.$global.tenantId,
      couponName: this.name,
      // couponStatus: this.searchStatus,
      pageNum,
      pageSize
    });
  }

  async getCouponList(pageNum: number = 1, pageSize: number = 10) {
    const { error, success }: any = await this.$store.dispatch(
      "coupon/getCouponList",
      {
        businessEntityId: this.$global.tenantId,
        couponName: this.name,
        couponStatus: this.searchStatus,
        pageNum,
        pageSize
      }
    );
    if (success) {
      this.pageNum = success.data.pageNum;
      this.pages = success.data.pages;
      this.loading = false;
      if (success.data.pageNum == success.data.pages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    }
    if (error) {
      this.loading = false;
      this.error = true;
    }
  }
 
  created() {
    console.log('123');
    this.$store.commit("coupon/resetCouponList");
  }
  toDetail(id:any){
    this.$router.push("/coupon/detail/"+id);
  }
  creat(){
    this.$router.push("/coupon/add");
  }

}
